import { useSelector } from 'react-redux'
import { selectDepots } from '@/features/domain/depot'

export const useHasDepots = () => {
  const depots = useSelector(selectDepots)

  return Object.keys(depots).length > 0
}
